let intervalId = 0;
const feed = document.getElementById("insta-feed");

const initializeSwiper = function () {
  const swiperEl = document.createElement("div")
  swiperEl.classList.add("swiper");
  
  const swiperWrapper = document.createElement("div");
  swiperWrapper.classList.add("swiper-wrapper");
  
  let items = feed.querySelectorAll(".instafeed-container");

  swiperEl.appendChild(swiperWrapper);
  for (const item of items) {
    item.classList.add("swiper-slide");
    swiperWrapper.appendChild(item);
  }

  feed.appendChild(swiperEl);

  const swiper = new Swiper(swiperEl, {
    slidesPerView: "auto",
    spaceBetween: 10,
    mousewheel: true,
    breakpoints: {
        768: {},
        1200: {}
    }
  });
  if (swiper.virtualSize > swiper.size) {
    swiperEl.classList.add("swiper--active");
  }

  swiper.on('resize', function (instance) {
    swiperEl.classList.toggle('swiper--active', instance.virtualSize > instance.size);
  });
}

if (feed) {
  var x = new MutationObserver(function (e) {
    for (const { addedNodes } of e) {
      for (const node of addedNodes) {
        if (node.classList.contains("instafeed-container")) {
          initializeSwiper();
          return;
        }
      }
    }
  });    
  x.observe(document.getElementById('insta-feed'), { childList: true });
}